// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBhjMZ-kcvsLFUU2AmiU6aaZ9kAt9O1160",
  authDomain: "christmas-site1.firebaseapp.com",
  projectId: "christmas-site1",
  storageBucket: "christmas-site1.firebasestorage.app",
  messagingSenderId: "977296111590",
  appId: "1:977296111590:web:07befb09a8504644394827"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };